import { TimeData } from '../../types';

export function formatTimeValue({ hour, minutes }: TimeData): string {
    const fullHour = `0${hour}`.slice(-2);
    const fullMinutes = `0${minutes}`.slice(-2);

    return `${fullHour}${fullMinutes}`;
}

export function getTimeFromInputValue(value: string, allowEndOfDay?: boolean): TimeData {
    const [hour, minutes] = value.split(':');

    const time = {
        hour: Number(hour) ?? 0,
        minutes: Number(minutes) ?? 0,
    };

    return fixTime(time, allowEndOfDay);
}

function fixTime({ hour, minutes }: TimeData, allowEndOfDay?: boolean): TimeData {
    let fixedHour = hour;
    let fixedMinutes = minutes - (minutes % 5);

    if (hour < 0 || hour > 23) {
        fixedHour = hour < 0 ? 0 : 23;
    }

    if (allowEndOfDay && minutes >= 59 && fixedHour === 23) {
        fixedMinutes = 59;
    } else if (fixedMinutes < 0 || fixedMinutes > 59) {
        fixedMinutes = fixedMinutes < 0 ? 0 : 55;
    }

    return {
        hour: fixedHour,
        minutes: fixedMinutes,
    };
}

export function fixMinMaxTime(time: TimeData, minTime?: TimeData, maxTime?: TimeData): TimeData {
    const fixedTime = time;

    if (minTime) {
        if (fixedTime.hour < minTime.hour) {
            fixedTime.hour = minTime.hour;
        }

        if (minTime.hour === fixedTime.hour && fixedTime.minutes < minTime.minutes) {
            fixedTime.minutes = minTime.minutes;
        }
    }

    if (maxTime) {
        if (fixedTime.hour > maxTime.hour) {
            fixedTime.hour = maxTime.hour;
        }

        if (maxTime.hour === fixedTime.hour && fixedTime.minutes > maxTime.minutes) {
            fixedTime.minutes = maxTime.minutes;
        }
    }

    return fixedTime;
}
